import { render, staticRenderFns } from "./publisher.vue?vue&type=template&id=3a433594&scoped=true"
import script from "./publisher.vue?vue&type=script&lang=js"
export * from "./publisher.vue?vue&type=script&lang=js"
import style0 from "./publisher.vue?vue&type=style&index=0&id=3a433594&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a433594",
  null
  
)

export default component.exports